import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AppProvider } from './context/AppContext';  // ← CHANGE THIS LINE

// Silence debug logging in production builds — keep warn/error so real problems still surface.
// (Dev builds keep all logging.) Removes the leftover console.log noise from the prod console.
if (process.env.NODE_ENV === 'production') {
  const noop = () => {};
  console.log = noop;
  console.info = noop;
  console.debug = noop;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

    <AppProvider>  
      <App />
    </AppProvider>  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
